import React from 'react';
import { Translation } from '../translations';

interface HowItWorksSectionProps {
  t: Translation;
}

const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({ t }) => {
  return (
    <section id="how-it-works" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t.howItWorks.title}
          </h2>
          <p className="text-xl text-gray-600">
            {t.howItWorks.subtitle}
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {t.howItWorks.steps.map((step, index) => (
            <div key={index} className="text-center relative">
              <div className="w-16 h-16 gradient-primary text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                {step.number}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
              {index < t.howItWorks.steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-gray-300" 
                     style={{ width: 'calc(100% - 4rem)', left: '58%' }}></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;